import getAffectedBlocksSelector from '../helpers/get-affected-blocks-selector';

const isAffectedBlock = (element) => {
  if (!element) return false;

  return element.matches(getAffectedBlocksSelector());
};

export default isAffectedBlock;
